import { createSlice } from "@reduxjs/toolkit";
import { IStore } from "helpers";

export const pgaFormReducer = createSlice({
  name: "pga form store",
  initialState: {
    isNavigated: false,
    logoutConfirmationClicked: true,
    formYear: 2024,
  },
  reducers: {
    setIsReadyNavigated: (state, action) => {
      state.isNavigated = action.payload;
    },
    setLogoutConfirmationClicked: (state, action) => {
      state.logoutConfirmationClicked = action.payload;
    },
    setFormYear: (state, action) => {
      state.formYear = action.payload;
    },
  },
});

export const { setIsReadyNavigated, setLogoutConfirmationClicked, setFormYear } = pgaFormReducer.actions;

export const getIsReadyNavigated = (state: IStore) => state.pgaForm.isNavigated;
export const getLogoutConfirmationClicked = (state: IStore) =>
  state.pgaForm.logoutConfirmationClicked;
export const getFormYear = (state: IStore) => state.pgaForm.formYear;

export default pgaFormReducer.reducer;
